export enum HierarchyItemAction {
    OpenQAManageModal,
    ShowAllSensorsHistory,
    UpdateSubtreeMeasurements,
}
